// Entry point for the build script in package.json

import "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import "trix";
import "@rails/actiontext";
import "core-js/stable";
// Bootstrap is already imported by Niiwin, so leave this line commented out.
// import "bootstrap";
import "@fortawesome/fontawesome-free/js/all.js";
import "tom-select/dist/js/tom-select.complete.js";

// Altcha captchas
import "altcha";

// eslint-disable-next-line import/first
import "./channels";
// eslint-disable-next-line import/first
import "./controllers";
import "./custom_turbo_actions";

ActiveStorage.start();

Turbo.StreamActions.push_state = function () {
  const url = this.getAttribute("url");
  if (url) {
    const currentState = window.history.state || {};
    window.history.pushState({ ...currentState }, "", url);
  }
};

Turbo.StreamActions.replace_state = function () {
  const url = this.getAttribute("url");
  if (url) {
    const currentState = window.history.state || {};
    window.history.replaceState({ ...currentState }, "", url);
  }
};

Turbo.StreamActions.redirect = function () {
  const url = this.getAttribute("url");
  if (url) {
    window.location.href = url;
  }
};
